import { render, staticRenderFns } from "./PaperlessPath.vue?vue&type=template&id=172ec68a"
import script from "./PaperlessPath.vue?vue&type=script&lang=js"
export * from "./PaperlessPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports